const CompatibilityChecker = (() => {
  const DISMISSED_KEY = 'compat-dismissed';
  let config = window.CompatibilityConfig || { COMPATIBILITY_RULES: {}, RECOMMENDED_ACCESSORIES: {} };

  function init() {
    // Listen for Shopify cart updates
    document.addEventListener('cart:updated', () => setTimeout(check, 200));
    // Initial check on page load
    setTimeout(check, 500); 
  }

  function updateConfig(newConfig) {
    config = { ...config, ...newConfig };
  }

  async function check() {
    try {
      const res = await fetch('/cart.json?cache=' + Date.now());
      const cart = await res.json();
      
      if (!cart.items || cart.items.length < 2) {
        sessionStorage.removeItem(DISMISSED_KEY);
        return;
      }

      const dismissed = JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]');

      // 1. Identify which tracker from our config is in the cart
      let activeRule = null;
      let isTrackerFound = null;

      for (const item of cart.items) {
        const ruleKey = Object.keys(config.COMPATIBILITY_RULES).find(key => 
          item.handle === key || item.handle.includes(key)
        );
        
        if (ruleKey) {
          activeRule = config.COMPATIBILITY_RULES[ruleKey];
          isTrackerFound = item;
          break;
        }
      }

      if (!isTrackerFound || !activeRule) {
        sessionStorage.removeItem(DISMISSED_KEY);
        return;
      }

      const correctAccessoryHandle = activeRule.recommended.handle;
      const recommendedVariantId = activeRule.recommended.variantId;

      // 2. Identify incompatible accessories (cases/mounts)
      const badItems = [];
      for (const item of cart.items) {
        if (item.handle === isTrackerFound.handle) continue;

        const handleLower = item.handle.toLowerCase();
        const titleLower = item.title.toLowerCase();
        const isCaseOrMount = handleLower.includes('case') || 
                            handleLower.includes('mount') || 
                            titleLower.includes('case') || 
                            titleLower.includes('mount');
        
        if (isCaseOrMount) {
          // If it's a accessory but not in the compatible list for this tracker
          if (!activeRule.compatible.includes(item.handle)) {
             badItems.push(item);
          }
        }
      }

      if (badItems.length > 0) {
        const variantIdsGroup = badItems.map(i => i.variant_id).sort().join(',');
        const warningKey = isTrackerFound.variant_id + '|' + variantIdsGroup;
        
        if (!dismissed.includes(warningKey)) {
          let recommendedTitle = 'Recommended Accessory';
          try {
            const prodRes = await fetch('/products/' + correctAccessoryHandle + '.js');
            const prodData = await prodRes.json();
            if (prodData && prodData.title) {
              recommendedTitle = prodData.title;
            }
          } catch(err) {
            // Fallback remains "Recommended Accessory"
          }

          showWarning(isTrackerFound, badItems, warningKey, recommendedTitle, recommendedVariantId);
        }
      } else {
        sessionStorage.removeItem(DISMISSED_KEY);
      }

    } catch (e) {
      // Fail silently
    }
  }

  function showWarning(tracker, items, key, recommendedTitle, recommendedVariantId) {
    const id = 'compat-warning-box';
    if (document.getElementById(id)) return;

    const box = document.createElement('div');
    box.id = id;
    box.style.cssText = `position: fixed; top: 15vh; left: 50%; transform: translateX(-50%); background: #ffffff; border: 3px solid #5c78e5; border-radius: 12px; padding: 25px; max-width: 90%; width: 450px; z-index: 2147483647; box-shadow: 0 15px 50px rgba(0,0,0,0.6); font-family: -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;`;

    const titlesList = items.map(i => i.title).join('", "');
    const isPlural = items.length > 1;

    box.innerHTML = `
      <style>
        .compat-modal-content { display: flex; gap: 15px; margin-bottom: 20px; align-items: flex-start; }
        .compat-icon { font-size: 32px; line-height: 1; }
        .compat-title { margin: 0 0 5px 0; color: #000000; font-size: 18px; font-weight: bold; }
        .compat-desc { margin: 0; color: #000000; font-size: 15px; line-height: 1.4; }
        .compat-recommendation { background: #fee2e2; border: 1px solid #ef4444; border-radius: 8px; padding: 15px; margin-bottom: 20px; }
        .compat-rec-title { margin: 0 0 5px 0; color: #000000; font-size: 13px; font-weight: bold; text-transform: uppercase; }
        .compat-rec-product { margin: 0; color: #000000; font-size: 15px; font-weight: 500; }
        .compat-buttons { display: flex; gap: 12px; }
        #compat-replace-btn {
          flex: 1;
          background: transparent linear-gradient(270deg, #5C78E5 0%, #57B4E1 100%) 0% 0% no-repeat padding-box;
          color: white; border: none; padding: 14px; border-radius: 6px; cursor: pointer; font-weight: bold; font-size: 15px; transition: all 0.2s ease-in-out !important;
        }
        #compat-replace-btn:hover { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(92, 120, 229, 0.3) !important; }
        #compat-dismiss-btn {
          background: white; color: #000000; border: 1px solid #000000; padding: 14px; border-radius: 6px; cursor: pointer; font-weight: bold; font-size: 14px; transition: all 0.2s ease-in-out !important;
        }
        #compat-dismiss-btn:hover { opacity: 0.7; transform: translateY(-1px); box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important; }
      </style>
      <div class="compat-modal-content">
        <div class="compat-icon">⚠️</div>
        <div>
          <h3 class="compat-title">Incompatible Setup!</h3>
          <p class="compat-desc">
            ${isPlural ? 'These items:' : 'The'} <strong>"${titlesList}"</strong> ${isPlural ? 'are' : 'is'} not compatible with your tracker.
          </p>
        </div>
      </div>
      <div class="compat-recommendation">
        <p class="compat-rec-title">RECOMMENDED FIX:</p>
        <p class="compat-rec-product">${recommendedTitle}</p>
      </div>
      <div class="compat-buttons">
        <button id="compat-replace-btn">Fix My Cart</button>
        <button id="compat-dismiss-btn">Keep As Is</button>
      </div>
    `;

    document.body.appendChild(box);

    const saveDismissedState = () => {
      const d = JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]');
      if (!d.includes(key)) d.push(key);
      sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(d));
    };

    document.getElementById('compat-replace-btn').onclick = async (e) => {
      e.target.textContent = 'Updating...';
      e.target.disabled = true;
      document.getElementById('compat-dismiss-btn').disabled = true;

      try {
        let sectionsToBundle = [];
        if (window.theme) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { 
            bubbles: true, 
            detail: { sections: sectionsToBundle } 
          }));
        }

        const updates = {};
        items.forEach(i => { updates[i.key] = 0; });
        updates[recommendedVariantId] = 1;

        const cartState = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            updates: updates,
            sections: sectionsToBundle.length ? sectionsToBundle : undefined,
            sections_url: window.location.pathname
          })
        }).then(res => res.json());

        saveDismissedState();
        box.remove();
        
        if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
          window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartState });
        } else {
          window.location.reload();
        }
      } catch (err) {
        e.target.textContent = 'Error. Try manually.';
        e.target.disabled = false;
        document.getElementById('compat-dismiss-btn').disabled = false;
      }
    };

    document.getElementById('compat-dismiss-btn').onclick = () => {
      saveDismissedState();
      box.remove();
    };
  }

  return { init, updateConfig };
})();

CompatibilityChecker.init();
